import { render, staticRenderFns } from "./ChartDoughnut.vue?vue&type=template&id=b268aaba&scoped=true"
import script from "./ChartDoughnut.vue?vue&type=script&lang=js"
export * from "./ChartDoughnut.vue?vue&type=script&lang=js"
import style0 from "./ChartDoughnut.vue?vue&type=style&index=0&id=b268aaba&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b268aaba",
  null
  
)

export default component.exports